var OSS = require('ali-oss');
export function client() {
  var client = new OSS({
    region: 'oss-cn-shanghai',
    accessKeyId: 'LTAI5tHC45ufB2MjT8jb9gVy',
    accessKeySecret: 'TLLzvOU63zSwcFa0GuZdWXgO1kKOod',
    bucket: 'monkeyshoppic'
  })  //后端提供数据
  return client
}



// WEBPACK FOOTER //
// ./src/utils/alioss.js